/*
 * File: /src/routes/routes.js
 * Created Date: Tuesday February 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 7th April 2019 11:09:21 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue';
// import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue';
import Login from 'src/components/Dashboard/Views/Pages/Login.vue';
import Offline from 'src/components/Dashboard/Views/Pages/Offline.vue';
import NotFound from 'src/components/GeneralViews/NotFoundPage.vue';
import { adminRoutes } from './admin';
import { analyticsRoutes } from './analytics';
import { assetsRoutes } from './assets';
import { automationRoutes } from './automations';
import { callCenterRoutes } from './callCenter';
import { campaignRoutes } from './campaigns';
import { companyRoutes } from './company';
import { connectorMapRoutes } from './connectorMap';
import { contentBlockRoutes } from './contentBlocks';
import { contactsRoutes } from './contacts';
import { pipelineRoutes } from './pipelines';
import { dashboardRoutes } from './dashboard';
import { emailRoutes } from './emails';
import { eventRoutes } from './events';
import { exportRoutes } from './exports';
import { groupRoutes } from './groups';
import { inboxRoutes } from './inbox';
import { interestsRoutes } from './interests';
import { leadTypeRoutes } from './leadTypes';
import { leadSourceRoutes } from './leadSources';
import { leadSourceDetailRoutes } from './leadSourceDetails';
import { leadStatusRoutes } from './leadStatuses';
import { referralsRoutes } from './referrals';
import { reportRoutes } from './reports';
import { reservationRoutes } from './reservations';
import { segmentsRoutes } from './segments';
import { settingsRoutes } from './settings';
import { surveyRoutes } from './surveys';
import { tagsRoutes } from './tags';
import { taskRoutes } from './tasks';
import { telRoutes } from './telephone';
import { templateRoutes } from './templates';
import { tokensRoutes } from './tokens';
import { voicemailRoutes } from './voicemail';
import { ownersRoutes } from './owners';
import { webhookRoutes } from './webhooks';
import { whatsappTemplateRoutes } from './whatsapptemplates';
import { airbnbTemplateRoutes } from './airbnbtemplates';
import { guidebookRoutes } from './guidebooks';
import { unitRoutes } from './units';
import { callResultTypeRoutes } from './callResultTypes';

// Below we'll use webpack code splitting.  This will keep the initial deliverable size down.
// reference: https://webpack.js.org/guides/code-splitting/

// Dashboard pages
const Overview = () =>
  import(
    /* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue'
  );

const ForgottenInviteAccount = () =>
  import(
    /* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Pages/Forgot.vue'
  );

const ProfileAccount = () =>
  import(
    /* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Profile/Account.vue'
  );

const SettingsOverview = () =>
  import(
    /* webpackChunkName: "Account" */ 'src/components/Dashboard/Views/Settings/SettingsOverview.vue'
  );

const loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
};

const forgottenPage = {
  path: '/:forgotten(forgotten|invite)/:token?/',
  name: 'Set Password',
  component: ForgottenInviteAccount,
};

const offlinePage = {
  path: '/offline',
  name: 'Offline',
  component: Offline,
};

// const lockPage = {
//   path: '/lock',
//   name: 'Lock',
//   component: Lock
// };

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview', // Default page
  },
  loginPage,
  forgottenPage,
  offlinePage,
  // lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview', // Default page
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        // This is the default overview.
        path: 'overview',
        name: 'Overview',
        component: Overview,
      },
      {
        path: 'settings-overview',
        name: 'Settings Overview',
        component: SettingsOverview,
      },
      {
        path: 'profile',
        name: 'Profile Settings',
        component: ProfileAccount,
      },
      ...callCenterRoutes,
      ...dashboardRoutes,
      ...adminRoutes,
      ...analyticsRoutes,
      ...assetsRoutes,
      ...companyRoutes,
      ...campaignRoutes,
      ...contentBlockRoutes,
      ...automationRoutes,
      ...contactsRoutes,
      ...templateRoutes,
      ...groupRoutes,
      ...segmentsRoutes,
      ...tagsRoutes,
      ...exportRoutes,
      ...interestsRoutes,
      ...leadTypeRoutes,
      ...leadSourceRoutes,
      ...leadSourceDetailRoutes,
      ...leadStatusRoutes,
      ...referralsRoutes,
      ...reservationRoutes,
      ...emailRoutes,
      ...telRoutes,
      ...taskRoutes,
      ...inboxRoutes,
      ...pipelineRoutes,
      ...voicemailRoutes,
      ...settingsRoutes,
      ...tokensRoutes,
      ...connectorMapRoutes,
      ...reportRoutes,
      ...eventRoutes,
      ...ownersRoutes,
      ...surveyRoutes,
      ...webhookRoutes,
      ...whatsappTemplateRoutes,
      ...airbnbTemplateRoutes,
      ...unitRoutes,
      ...callResultTypeRoutes,
      ...guidebookRoutes,
    ],
  },

  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
];

export default routes;
